import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./features/auth/authSlice";
import categoryReducer from "./features/product/categorySlice";
import productReducer from "./features/product/productSlice";
import saleReducer from "./features/sales/saleSlice";
import orderReducer from "./features/orders/orderSlice";
import bulkProductReducer from "./features/product/bulkProductSlice";
import reportReducer from "./features/sales/reportSlice";
import expenseReducer from "./features/expense/expenseSlice";
import attributeReducer from "./features/product/attributeSlice";
import productBatchReducer from "./features/product/productBatchSlice";
import customerReducer from "./features/sales/customerSlice";
import stockAdjustmentReducer from "./features/sales/stockAdjustmentSlice";
import saleReturnReducer from './features/sales/saleReturnSlice';
import shiftClosingReducer from './features/sales/shiftClosingSlice';




export default configureStore({
    reducer: {
        auth: authReducer,
        category: categoryReducer,
        product: productReducer,
        sale: saleReducer,
        order: orderReducer,
        bulkProduct: bulkProductReducer,
        report: reportReducer,
        expense: expenseReducer,
        attribute: attributeReducer,
        productBatch: productBatchReducer,
        customer: customerReducer,
        stockAdjustment: stockAdjustmentReducer,
        saleReturn: saleReturnReducer,
        shiftClosing: shiftClosingReducer,
    },
});


